import {
  Container,
  Backdrop,
  Box,
  Paper,
  Stack,
  StackProps,
  Typography,
  CircularProgress,
  Fade,
} from '@mui/material'

type LoadingProps = {
  percent?: number
  caption?: string
} & StackProps
export const Loading = ({
  percent,
  caption,
  ...others
}: LoadingProps) => (
  <Fade in timeout={1000}>
    <Stack
      {...others}
      justifyContent="center"
      alignItems="center"
      sx={{
        position: 'absolute',
        zIndex: 99,
        top: 0, left: 0, right: 0, bottom: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(128,128,128,0.1)'
      }}
    >
      <Paper
        variant="elevation"
        elevation={2}
        square={false}
        style={{ opacity: 0.8 }}
      >
        <Stack
          padding={4}
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          {caption && (
            <Typography variant="caption" color="text.secondary">
              {caption}
            </Typography>
          )}
          {percent ? (
            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
              <CircularProgress
                variant="determinate"
                value={percent}
                size="3rem"
                sx={{ transition: 'none' }}
                disableShrink
              />
              <Box
                sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: 'absolute',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  variant="body2"
                  component="div"
                  color="text.secondary"
                >{`${Math.round(percent)}%`}</Typography>
              </Box>
            </Box>
          ) : (
            <CircularProgress />
          )}
        </Stack>
      </Paper>
    </Stack>
  </Fade>
)

export const LoadingPage = () => {
  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  )
}
